export default "/images/ic_remove.svg?b066bb94a641dffd656bc27ef3db48cf";